import React from 'react';

export const Home = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M20.1087 16.297V9.10209C20.1087 8.78274 19.9561 8.48259 19.6982 8.29433L12.5895 3.10637C12.2383 2.85006 11.7617 2.85006 11.4105 3.10637L4.30179 8.29433C4.04383 8.48259 3.8913 8.78274 3.8913 9.10209V19C3.8913 19.5523 4.33901 20 4.8913 20H19.1087C19.661 20 20.1087 19.5523 20.1087 19V16.1485"
      stroke={color || '#7D7A9A'}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M15 20V21H16V20H15ZM9 20H8V21H9V20ZM10 13H14V11H10V13ZM14 13V20H16V13H14ZM15 19H9V21H15V19ZM10 20V13H8V20H10ZM14 13H16C16 11.8954 15.1046 11 14 11V13ZM10 11C8.89543 11 8 11.8954 8 13H10V11Z"
      fill={color || '#7D7A9A'}
    />
  </svg>
);
